<template>
  <div class="g-content">
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>{{ $t('role_list_title') }}</h3>

        <a-button
          type="primary"
          @click="$refs.update.show()"
          icon="plus"
          v-auth="['auth_role_add']"
        >
          {{ $t('role_btn_add') }}
        </a-button>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="g-table">
        <NetworkError v-if="networkError" />
        <a-table
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :rowKey="(_text, index) => index"
          bordered
          size="small"
          v-else
        >
          <!-- 名称 -->
          <template slot="Name" slot-scope="text, record">
            <div
              @click="$refs.update.editRole(record)"
              style="text-decoration: underline;cursor: pointer;"
              v-if="authList.includes('auth_role_edit') || isSuperAdmin"
            >
              {{ text }}
            </div>
            <div v-else>
              {{ text }}
            </div>
          </template>

          <!-- 创建时间 -->
          <template slot="createTime" slot-scope="text">
            <span v-if="text">
              {{ text | formatDate }}
            </span>
            <span v-else>--</span>
          </template>

          <!-- 操作 -->
          <template slot="Action" slot-scope="text, record">
            <router-link
              :to="`/manage/system/role/auth/menu/${record.id}`"
              v-auth="['auth_role_authMenu']"
            >
              <a-button type="default" size="small">
                {{ $t('role_btn_auth_menu') }}
              </a-button>
            </router-link>

            <router-link
              :to="`/manage/system/role/auth/data/${record.id}`"
              v-auth="['auth_role_authData']"
            >
              <a-button type="default" size="small">
                {{ $t('role_btn_auth_data') }}
              </a-button>
            </router-link>

            <a-button
              type="primary"
              size="small"
              @click="$refs.update.editRole(record)"
              v-auth="['auth_role_edit']"
            >
              {{ $t('com_btn_edit') }}
            </a-button>

            <a-button
              type="danger"
              size="small"
              @click="deleteRole(record)"
              v-auth="['auth_role_delete']"
            >
              {{ $t('com_btn_delete') }}
            </a-button>
          </template>
        </a-table>
      </div>
    </div>

    <!-- 新增/编辑 -->
    <Update ref="update" :callback="getRoleList" v-auth="['auth_role_edit', 'auth_role_add']" />
  </div>
</template>
<script>
import * as API from '@/api/system/role';
import Update from './update.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Update,
  },
  data() {
    return {
      // 表头
      columns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
          width: 60,
        },
        {
          title: this.$t('com_table_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'Name' },
        },

        {
          title: this.$t('com_form_description'),
          dataIndex: 'description',
        },
        {
          title: this.$t('com_table_created_time'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
      ],

      // 数据
      list: [],

      // 新增
      addEditVisible: false,
      // 搜索
      addEditForm: {
        name: undefined,
        description: undefined,
      },
      addEditError: '',
      addEditType: '',
      addEditLoading: false,

      networkError: false,
    };
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
  },
  created() {
    this.getRoleList();

    // 权限操作
    if (
      this.authList.includes('auth_role_delete') ||
      this.authList.includes('auth_role_authData') ||
      this.authList.includes('auth_role_authMenu') ||
      this.authList.includes('auth_role_edit') ||
      this.isSuperAdmin
    ) {
      this.columns.push({
        title: this.$t('com_table_operation'),
        dataIndex: 'Action',
        scopedSlots: { customRender: 'Action' },
      });
    }
  },
  methods: {
    getRoleList() {
      this.networkError = false;
      API.RoleListAll()
        .then(res => {
          this.list = res.data || [];
        })
        .catch(() => {
          this.networkError = true;
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
        });
    },

    // delete
    deleteRole(record) {
      const _this = this;
      this.$confirm({
        title: this.$t('role_confirm_delete_title'),
        content: this.$t('role_confirm_delete_content', { name: record.name }),
        centered: true,
        okText: this.$t('com_btn_confirm'),
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.RoleDelete({ roleId: record.id })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getRoleList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.add-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}
</style>
